/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/variants/:variant_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { putDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdProps,
  PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantId =
  reactQueryMutationAdapter(
    putDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdCacheKeys,
    (
      props: PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdProps
    ): Promise<PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult> => {
      return fetch(
        `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/creative_components/${props.component}/variants/${props.variant_id}`,
        "PUT",
        {
          creative: props.creative,
          base_creative_campaign_ids: props.base_creative_campaign_ids,
          write_mode: props.write_mode,
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  );
